import { rgba } from "polished";
import { css } from "styled-components";
import Icon from "../../../../../../../../../base/icons/icon/index.js";
import { FontMixin } from "../../../../../../../../../../styles/common/mixins/helpers.styled.js";
const veciPanelAccommodationStyles = {
    PanelAccommodationRoomHeader: ()=>css`
		background-color: ${({ theme  })=>rgba(theme.colors.grays.lightest ?? theme.colors.grays.base, 0.56)};
		border-color: ${({ theme  })=>theme.colors.grays.lightest};

		&:first-of-type {
			border-top: 0;
		}

		& > p {
			text-transform: capitalize;
			color: ${({ theme  })=>theme.colors.text.dark};
			${FontMixin({
            weight: 'semiBold',
            height: 'base'
        })};
		}
	`,
    PanelAccommodationRoomHeaderIcon: ()=>css`
		${Icon} {
			color: ${({ theme  })=>theme.colors.primary.base};
		}
	`
};
export default veciPanelAccommodationStyles;

//# sourceMappingURL=veci.js.map